/**
 * Keeps the SMS marketing consent and the phone number in sync inside the
 * newsletter signup blocks (`email-signup`, `email-signup-makecom`).
 *
 * Ticking the consent without a phone number is meaningless, so the phone field
 * is marked invalid with an explanatory message. Native constraint validation
 * then blocks the submit and shows the message — which also stops the AJAX
 * handler in `email-signup-makecom.js`, because `submit` never fires for an
 * invalid form.
 */

const PHONE_SELECTOR = '[data-phone-input]';
const CONSENT_SELECTOR = '[data-sms-consent]';
const DEFAULT_MESSAGE = 'Zaznaczono zgodę na SMS — podaj numer telefonu.';

/** Forms already wired up, so re-running the setup is harmless. */
const bound = new WeakSet();

/** @param {HTMLFormElement} form */
function bind(form) {
  if (bound.has(form)) return;

  const phone = form.querySelector(PHONE_SELECTOR);
  const consent = form.querySelector(CONSENT_SELECTOR);
  if (!(phone instanceof HTMLInputElement) || !(consent instanceof HTMLInputElement)) return;

  bound.add(form);

  const message = consent.dataset.smsConsentMessage || DEFAULT_MESSAGE;

  const sync = () => {
    const missingPhone = consent.checked && phone.value.trim() === '';
    phone.setCustomValidity(missingPhone ? message : '');
  };

  consent.addEventListener('change', sync);
  phone.addEventListener('input', sync);
  phone.addEventListener('change', sync);

  // Autofill can populate the field before any event of ours fires.
  sync();
}

function bindAll(root = document) {
  for (const consent of root.querySelectorAll(CONSENT_SELECTOR)) {
    const form = consent.closest('form');
    if (form) bind(form);
  }
}

bindAll();

// The theme editor swaps section markup without reloading the page.
document.addEventListener('shopify:section:load', (event) => {
  const target = event.target;
  bindAll(target instanceof Element ? target : document);
});
